<template lang="pug">
Tabs.ticket-hub
    //- Nothing is saved here, so the only button is the way back to the list —
    //- as a circle in the tab bar and labelled below, like every other page.
    //- The mutation-free navigation lives in TicketGanttChart — see dismiss()
    //- there for why.
    template(slot="tabbar-buttons")
        el-button(
            circle
            icon="el-icon-fa-times fas"
            @click="callGantt('dismiss')"
        )
    //- contains-table: a panel card is flush (body padding 0) and its content
    //- carries the spacing, the way every paginated list in the admin is built.
    el-card.contains-table(shadow="always")
        ticket-gantt-chart(ref="gantt" scope="cms" :cms-id="cmsId")
    .buttons-flex
        .form-buttons
        .form-buttons
            el-button(round icon="el-icon-fa-times fas" @click="callGantt('dismiss')") {{ $t('Dismiss') }}
</template>

<i18n>
{
    "de": {
        "Dismiss": "Verwerfen"
    }
}
</i18n>

<script>
import pinia from '@/pinia';
import { useSetupStore } from '@/stores';

import Tabs from '@/extensions/communication/views/Partials/Tabs';
import TicketGanttChart from '@/extensions/tickets/views/TicketGanttChart';

// Pure chrome: the message-hub tab bar and its Dismiss button. The
// navigation it triggers lives on TicketGanttChart itself and is reached
// through callGantt() — one copy, shared with the system wrapper.
export default {
    name: 'CmsTicketGantt',
    components: {
        Tabs,
        TicketGanttChart,
    },
    computed: {
        cmsId() {
            return useSetupStore(pinia).activeCms.id;
        },
    },
    methods: {
        callGantt(method, ...args) {
            const gantt = this.$refs.gantt;
            if (gantt) gantt[method](...args);
        },
    },
};
</script>
